<script setup>
defineProps({
    oldValue: [String, Array],
    newValue: [String, Array]
})
</script>

<template>
    <div>
        <div class="small pb-3">
            <p class="pb-2 border-bottom fw-bold">Old value</p>
            <small>{{ oldValue }}</small>
        </div>

        <div class="small">
            <p class="py-2 border-bottom border-top fw-bold">New value</p>
            <small>{{ newValue }}</small>
        </div>
    </div>
</template>